/**
 * User can work on multiple browser tabs. (Normally, those tabs belong to one session, see P.S. for more info).
 * For example, I am logged in as artum@servc.co.il and have two tabs opened simultaneously.
 *
 * There are three problems that can occur:
 * 1) in one tab a user wants to log out, what should the second tab do?
 * 2) delay issue (fixed but have to be documented for the future):
 * User opens a browser with two saved tabs from before. User is working in the first tab.
 * User provided the correct credentials for login and received a temp token (in a cookie).
 * The second tab is slowly loading the page and opens login page.
 * Login page broadcasts everyone to sign out and clears the cookies (incl the temp auth token for sms).
 * User cannot login =/
 * 3) when a user logs in, we need to clear all other cookies and sessions.
 *
 * The solution is as follows:
 * We define a session leader and session cheburek.
 * a) session leader is the tab, in which
 *  1) user clicked the login button and will have to do the 2fa.
 *  2) user signed out through hornavbar (as usual).
 *  3) user signed out from the modal-stay.component.
 * b) cheburek is a tab which lives its life: grows kids, plants trees and uses orcainc for their investments.
 * Most importantly, it is a tab which is not currently active.
 *
 * Now we want to set a session leader. This is done by {@link setSessionLeaderByLogout}.
 * Again, the session leader is the one who says that we need to sign out.
 *
 * When a session leader signs out, the session leader
 * 1) Clears cookies.
 * 2) Clears localstorage.
 * 3) Goes to login.
 * 4) Broadcasts to all tabs that they have to do "sign out".
 * In that case it is enough to show a modal-expired-session.component.
 * It is because the session leader clears all the cookies.
 *
 * But since a session leader is accepting the broadcasted message themself (bro, leader can be he/she/they, it is 2k25),
 * session leader does NOT have to show the modal. Therefore, we need {@link getAmISessionLeaderByLogout}.
 *
 * =====================
 *
 * Idea behind this class is simple:
 * We use session storage to save the last time a tab submitted the sign out.
 * If it is in the last {@link amountOfSecondsToCountAsLeader}, then we count as leader.
 * The communication between tabs is always fast, in couple of ms. But to make sure I set 2 seconds. See the next paragraph.
 *
 * Usually, tabs will have null in the session storage,
 * but if a user duplicates a tab, the new tab inherits all the values from the init tab.
 * Therefore, we need to check the latest {@link amountOfSecondsToCountAsLeader}.
 *
 * P.S. It is possible to have two separate sessions at the same time:
 * 1) using different browsers.
 * 2) using incognito and normal mode.
 */
export class SessionExpirationService {
  static setSessionLeaderByLogout(): void {
    sessionStorage.setItem(sessionLeaderString, new Date().getTime().toString());
  }

  static getAmISessionLeaderByLogout(): boolean {
    const lastLeaderTimestamp = sessionStorage.getItem(sessionLeaderString);
    if (!lastLeaderTimestamp) {
      return false;
    }
    const now = new Date().getTime();
    const diffInSeconds = (now - (Number(lastLeaderTimestamp))) / 1000;
    return diffInSeconds <= amountOfSecondsToCountAsLeader;
  }
}

const sessionLeaderString = 'sessionLeader';
const amountOfSecondsToCountAsLeader = 2;
